import { createContext, useContext, useEffect, useState } from 'react';
import api, { getBranchCache, setBranchCache } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const [branches, setBranchesState] = useState(getBranchCache());

  const refreshBranches = async () => {
    const { data } = await api.get('/branches');
    setBranchCache(data);
    setBranchesState(data);
  };

  useEffect(() => {
    const token = localStorage.getItem('lodi_token');
    if (!token) {
      setUser(null);
      return;
    }
    api.get('/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem('lodi_token');
        setUser(null);
      });
  }, []);

  useEffect(() => {
    if (user) refreshBranches().catch(() => {});
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const login = async (userId, pin) => {
    const { data } = await api.post('/auth/login', { user_id: userId, pin });
    localStorage.setItem('lodi_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('lodi_token');
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, login, logout, branches, refreshBranches }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
